import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useStyles = makeStyles({
  dialogSurface: {
    "@media (max-width: 640px)": {
      minWidth: "unset",
      width: "calc(100vw - 32px)",
      maxWidth: "100%",
    },
  },
  dialogBody: {
    display: "block",
  },
  spinner: {
    marginTop: designTokens.spacing[4],
  },
  button: {
    color: designTokens.neutral.white,
    backgroundColor: designTokens.accent[500],
    ":hover": {
      color: designTokens.neutral.white,
      backgroundColor: designTokens.accent[600],
    },
    ":active": {
      backgroundColor: designTokens.accent[700],
    },
    "@media (max-width: 640px)": {
      minHeight: "44px",
      minWidth: "44px",
    },
  },
  dangerButton: {
    color: designTokens.neutral.white,
    backgroundColor: designTokens.semantic.error,
    ":hover": {
      color: designTokens.neutral.white,
      backgroundColor: designTokens.semantic.error,
      opacity: 0.9,
    },
    ":active": {
      backgroundColor: designTokens.semantic.error,
      opacity: 0.8,
    },
    "@media (max-width: 640px)": {
      minHeight: "44px",
      minWidth: "44px",
    },
  },
});
